export const REQUEST_PROFILE_HEADER_STATUS_SELECT_QA_NAME =
  'requestProfileHeaderStatusSelect'

export const REQUEST_PROFILE_HEADER_STATUS_SELECT_DROPDOWN_MAX_HEIGHT = 352
